export class activateContractDataMode {
  action: string;
  contractId: number;
  contractStatus: number;
  strDate: Date;
  endDate: Date;
  clientId: number
}
